<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="4"
      :xl="4"
    >
      <Filters
        v-model="filters"
        advanced
        :resource="$sdk.ratesurcharge"
        :primary-fields="[ 'carrier', 'group.indices.account', 'type', 'date_start', 'date_end', 'active' ]"
        :setup-fields="{ date_end: setupDateEndFilterable }"
        @sort="sort = $event; $refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="20"
      :xl="20"
    >
      <el-card
        shadow="never"
      >
        <SurchargesTable
          ref="table"
          :filters="filters"
          :sort="sort"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import SurchargesTable from '@/components/Application/Manage/Surcharges/SurchargesTable'
import { IS_EMPTY } from '@/plugins/sdk/Filter'

export default {
  components: {
    Filters,
    SurchargesTable
  },
  data () {
    return {
      title: 'Surcharges',
      breadcrumb: {
        name: 'Surcharges',
        route: { name: 'manage-surcharges' }
      },
      actions: [],
      filters: [],
      sort: {
        field: 'name',
        direction: 'asc'
      }
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  },
  methods: {
    setupDateEndFilterable (filterable) {
      filterable.filter.operator = IS_EMPTY
    }
  }
}
</script>
